import React, { useState } from 'react';
import { Link, router } from '@inertiajs/react';
import Layout from '../../components/Layout.jsx';

export default function SupportNew({ ticket = { subject: '', body: '' } }) {
  const [subject, setSubject] = useState(ticket.subject || '');
  const [body, setBody] = useState(ticket.body || '');
  const [submitting, setSubmitting] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!subject.trim() || !body.trim()) return;
    setSubmitting(true);
    router.post('/support', {
      support_ticket: { subject: subject.trim(), body: body.trim() },
    }, {
      onFinish: () => setSubmitting(false),
    });
  };

  return (
    <Layout>
      <div className="max-w-3xl mx-auto p-6 sm:p-8 space-y-6">
        <div>
          <Link href="/support" className="text-sm font-semibold text-indigo-600 hover:text-indigo-700">
            ← Back to support
          </Link>
          <h1 className="text-3xl font-bold tracking-tight text-gray-900 mt-2">New support request</h1>
          <p className="mt-1 text-sm text-gray-500">Tell us what's going on and we'll get back to you here.</p>
        </div>

        <form onSubmit={handleSubmit} className="bg-white border border-gray-200 rounded-2xl p-6 shadow-sm space-y-5">
          <div>
            <label htmlFor="ticket_subject" className="block text-sm font-semibold text-gray-700 mb-1.5">
              Subject
            </label>
            <input
              id="ticket_subject"
              type="text"
              value={subject}
              maxLength={200}
              onChange={(e) => setSubject(e.target.value)}
              placeholder="Brief summary of your question"
              className="block w-full rounded-lg border border-gray-200 bg-white px-3.5 py-2.5 text-sm text-gray-900 placeholder:text-gray-400 focus:border-indigo-500 focus:ring-2 focus:ring-indigo-500/20 focus:outline-none transition"
              required
            />
          </div>

          <div>
            <label htmlFor="ticket_body" className="block text-sm font-semibold text-gray-700 mb-1.5">
              Message
            </label>
            <textarea
              id="ticket_body"
              value={body}
              rows={8}
              maxLength={10000}
              onChange={(e) => setBody(e.target.value)}
              placeholder="Share as much detail as you can — links, screenshots, what you've already tried, etc."
              className="block w-full rounded-lg border border-gray-200 bg-white px-3.5 py-2.5 text-sm text-gray-900 placeholder:text-gray-400 focus:border-indigo-500 focus:ring-2 focus:ring-indigo-500/20 focus:outline-none transition resize-y"
              required
            />
            <p className="mt-1 text-xs text-gray-400">{body.length}/10,000</p>
          </div>

          <div className="flex justify-end gap-3">
            <Link
              href="/support"
              className="inline-flex items-center justify-center px-4 py-2.5 text-sm font-semibold rounded-lg text-gray-700 bg-white border border-gray-200 hover:bg-gray-50 transition"
            >
              Cancel
            </Link>
            <button
              type="submit"
              disabled={submitting || !subject.trim() || !body.trim()}
              className="inline-flex items-center justify-center gap-2 rounded-lg bg-indigo-600 px-4 py-2.5 text-sm font-semibold text-white shadow-sm hover:bg-indigo-700 disabled:opacity-50 disabled:cursor-not-allowed transition cursor-pointer"
            >
              {submitting ? 'Sending…' : 'Send request'}
            </button>
          </div>
        </form>
      </div>
    </Layout>
  );
}
